export default {
    EXACT_URL: 'URL',
    PATH_URL: 'Path',
    ROOT_DOMAIN: 'Domain',
    SUBDOMAIN: 'Subdomain',
};
